import {MODELS} from "../services/models";
import store from "../store";
import api from "../api";
import { subscribeToChannel, unsubscribeToChannel } from "../services/pusher";

const state = () => ({
  filters: {
    users: [],
    temperature: null,
    dealProbabilityScore: null,
    tag: null,
    required: null,
    display: null,
    pageView: "calendar"
  },
  pendingAppointments: [],
  incompleteTasks: [],
  requiredFilterEnum: {
    "NoFilter": {
      value: null,
      label: "No Filter"
    },
    "No": {
      value: 1,
      label: "No"
    },
    "Yes": {
      value: 2,
      label: "Yes"
    }
  }
});

const getters = {
  filters(state) {
    return state.filters;
  },
  pageView(state) {
    return state.filters.pageView;
  },
  pendingAppointments(state) {
    if (state.filters.display === undefined
      || state.filters.display === null
      || state.filters.display === MODELS.Appointment.class_name
    ) {
      return state.pendingAppointments;
    }

    return [];
  },
  incompleteTasks(state) {
    if (state.filters.display === undefined
      || state.filters.display === null
      || state.filters.display === MODELS.Task.class_name
    ) {
      return state.incompleteTasks;
    }

    return [];
  },
};

const mutations = {
  setOneFilter(state, [filter, value]) {
    state.filters[filter] = value;
  },
  setUserFilters(state, filters) {
    /**
     * make sure this match the filters declared on state
     * this will remove old filter key
     */
    Object.entries(state.filters).forEach(([key, value]) => {
      if (filters.hasOwnProperty(key)) {
        state.filters[key] = filters[key];
      } else {
        state.filters[key] = value;
      }
    });
  },
  reset(state) {
    state.filters = {
      users: [],
      temperature: null,
      dealProbabilityScore: null,
      tag: null,
      required: null,
      display: null,
      pageView: "calendar"
    };
    store.dispatch('updateUserAppFilter');
  },
  setIncompleteTasks(state, tasks) {
    state.incompleteTasks = tasks;
  },
  setPendingAppointments(state, appointments) {
    state.pendingAppointments = appointments;
  },
  teardown(state) {
    state.incompleteTasks = [];
    state.pendingAppointments = [];
  },
};

const actions = {
  setup({commit, dispatch, rootGetters}) {
    subscribeToChannel('upNext', rootGetters.account.id);
  },
  teardown({commit, rootGetters}) {
    unsubscribeToChannel('upNext', rootGetters.account.id);
    commit('teardown');
  },
  fetchEvents({commit, state, rootState, getters}, dates) {
    const filters = {...getters.filters}
    filters.start_at = dates.start_at;
    filters.end_at = dates.end_at;

    const tasks = api.clientStore.getTasks(rootState.market.market.id, filters);
    const initAppointments = api.clientStore.getAppointments(rootState.account.account.id, filters);

    return Promise.all([tasks, initAppointments])
      .then(([resTasks, resAppointments]) => {
        commit('setIncompleteTasks', resTasks.data);
        commit('setPendingAppointments', resAppointments.data);
      })
      .catch(err => {
        commit('setIncompleteTasks', []);
        commit('setPendingAppointments', []);
      });
  },
};

const UpNextStore = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

export default UpNextStore;
